export default class BlockUIActionTypes {
  public static START = 'START';

  public static STOP = 'STOP';
}
